import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
    fabricantsResource,
    modelsTruckTrailerResource,
} from "../../helpers/configRoutes/backend_helper";
import CustomInput from "../../components/form/CustomInput";
import { showFormErrors } from "../../helpers/showFormErrors";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import CustomButton from "../../components/form/CustomButton";

const AddCatalogsModal = ({
    modal,
    setModal,
    validation,
    setModels,
    setFabricants,
    isTruck,
}) => {
    const [loading, setLoading] = useState(false);

    const isFabricant = modal.title === "Fabricant" || modal.title === "Manufacturer";

    const validationCatalog = useFormik({
        initialValues: {
            id: null,
            name: "",
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
        }),
        onSubmit: async (values, { setErrors, resetForm }) => {
            setLoading(true);
            let response = {};

            if (!isFabricant) {
                // Model
                values.fabricant_id = validation.values?.fabricant_id;
                values.truck = isTruck;
                response = await modelsTruckTrailerResource(
                    "post",
                    values,
                    values.id
                );
                if (response.status) {
                    setModels(response.models);
                    validation.setFieldValue("model_id", response.id);
                }
            } else {
                // Fabricant
                response = await fabricantsResource("post", {
                    ...values,
                    truck: isTruck,
                }, values.id);
                if (response.status) {
                    setFabricants(response.fabricants);
                    validation.setFieldValue("fabricant_id", response.id);
                }
            }

            if (response.status) {
                resetForm();
                setModal({ ...modal, show: false });
            } else {
                setErrors(response.errors || {});
            }
            setLoading(false);
        },
    });

    return (
        <BaseModalAnimated
            modal={modal}
            setModal={setModal}
            title={modal.title || "New item"}
        >
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    validationCatalog.handleSubmit();
                    showFormErrors(validationCatalog);
                    return false;
                }}
            >
                <div className="bg-cs-bg rounded-2xl overflow-hidden">
                    {/* Header */}
                    <div className="px-5 py-3 border-b border-cs-border bg-cs-surface">
                        <div className="flex flex-col">
                            <p className="text-[10px] uppercase tracking-[0.16em] text-cs-primary-dark">
                                {isFabricant ? "Add fabricant" : "Add model"}
                            </p>
                            <p className="text-[9px] text-cs-muted">
                                {isFabricant
                                    ? `Create a new ${isTruck ? "truck" : "trailer"} manufacturer to assign to your units.`
                                    : `Create a new model linked to the selected ${isTruck ? "truck" : "trailer"} manufacturer.`}
                            </p>
                        </div>
                    </div>

                    {/* Body */}
                    <div className="px-5 py-4 bg-cs-bg-alt">
                        <CustomInput
                            label="Name"
                            type="text"
                            name="name"
                            labelClassName="text-[10px] font-medium text-cs-muted mb-1"
                            error={validationCatalog?.errors?.name}
                            value={validationCatalog?.values?.name}
                            handleChange={validationCatalog.handleChange}
                            className="text-[11px]"
                            placeholder={
                                isFabricant
                                    ? "e.g. Freightliner, Great Dane..."
                                    : "e.g. Cascadia 2024..."
                            }
                        />
                    </div>

                    {/* Footer */}
                    <div className="px-5 py-3 bg-cs-bg border-t border-cs-border flex justify-end">
                        <CustomButton
                            loading={loading}
                            textLoad="Saving..."
                            type="success"
                            className="
                                bg-cs-primary
                                hover:bg-cs-primary-hover
                                text-white
                                px-4 py-2
                                rounded-xl
                                text-[10px] font-medium
                                shadow-sm hover:shadow-md
                            "
                        >
                            Save {modal.title}
                        </CustomButton>
                    </div>
                </div>
            </form>
        </BaseModalAnimated>
    );
};

export default AddCatalogsModal;
